import { HelpCenter } from "@mui/icons-material";
import { Stack, Typography } from "@mui/material";
import missingImage from "../assets/images/no-image_100.png";


const RenderProduct = ({ src, name }: { src: string; name: string }) => {
  try {
    const img = src?.length > 0 ? src : missingImage;
    return <img 
      src={img}
      alt={name}
      style={{maxHeight: '100%', maxWidth: '100%'}}
      onError={({ currentTarget }) => {
        currentTarget.onerror = null; // prevents looping
        currentTarget.src=missingImage
      }}
    />
  } catch (err) {
    //Do whatever you want when the image failed to load here
  }

  return (
    <Stack
      justifyContent="center"
      alignItems="center"
      spacing="4px"
      sx={{ height: "70px" }}
    >
      <HelpCenter />
      <Typography variant="bodySmallWeightRegular">Image not found</Typography>
    </Stack>
  );
};

export default RenderProduct;
